export const CONSENT_COOKIE_NAME = 'euconsent-v2'

export const USER_HEADER_COOKIE_NAME = 'userHeader'
